<template>
  <transition name="dialog-fade">
    <div :class="$style['expand-widget-popup']" v-show="visible">
      <component :is="widgetView" :layout="layout" :is-expand="true"/>
    </div>
  </transition>
</template>

<script>
import Base from '@/mixins/dashboard/base';

export default {
  name: 'WWidgetExpandPopup',
  components: {
  },
  mixins: [Base],
  data() {
    return {
      visible: false,
      widgetView: null,
    };
  },
  computed: {
    expandWidgetId() {
      return this.$store.getters.getExpandWidgetId;
    },
    layout() {
      return {
        i: this.expandWidgetId,
      };
    },
  },
  watch: {
    expandWidgetId(widgetId) {
      this.visible = widgetId !== null;

      setTimeout(() => {
        this.widgetView = widgetId !== null ? this.$store.getters.getWidgetViewComponent[this.dashboardWidget[widgetId].widgetTemplId] : null;
      }, 500);
    },
  },
  created() {
  },
  beforeDestroy() {
  },
  methods: {
  },
};
</script>

<style module>
.expand-widget-popup {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/popup/WidgetExpandPopup.vue